import { render, staticRenderFns } from "./DeviceRelationForm.vue?vue&type=template&id=f8d6ecac&"
import script from "./DeviceRelationForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceRelationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports